import React from 'react'
import PropTypes from 'prop-types'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress';

export default function LoadingRow({HeaderRow, colSpan}) {
	return (
		<Table>
			<HeaderRow />
			<TableBody>
				<TableRow>
					<TableCell colSpan={colSpan} style={{textAlign: 'center'}}>
						<CircularProgress size={30}/>
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	)
}

LoadingRow.propTypes = {
	colSpan: PropTypes.number.isRequired,
}